import React from "react"

import { AttachmentFragment } from "entities/attachments/graphql/fragments.generated"

import { ReplaceAttachmentOverlay } from "./ReplaceAttachmentOverlay"
import { useReplaceAttachmentOverlayModel } from "./model/useReplaceAttachmentOverlayModel"

export interface ReplaceAttachmentOverlayPayload {
  projectID: string
  attachment: AttachmentFragment
}

export interface ReplaceAttachmentOverlayConnectorProps {
  payload: ReplaceAttachmentOverlayPayload
}

export const ReplaceAttachmentOverlayConnector = React.memo(
  (props: ReplaceAttachmentOverlayConnectorProps) => (
    <ReplaceAttachmentOverlay {...useReplaceAttachmentOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    REPLACE_ATTACHMENT_OVERLAY: ReplaceAttachmentOverlayPayload
  }
}
